import React from 'react';
import { ProjectResponse } from '../../../core/models/Project';
import { IconBootstrap } from '../../shared/Icon';
import { Badge } from '../../shared/Badge';
import { useTranslation } from 'react-i18next';
import { TranslatedString } from '../../../core/models/TranslatedString';
import { DeleteButton } from '../../shared/button/DeleteButton';
import { Card } from '../../shared/Card';
import { ViewButton } from 'components/shared/button/ViewButton';

type Props = {
    project: ProjectResponse;
    onClick: () => void;
    onDelete: () => void;
    onView?: () => void;
};

export const ProjectCard = ({
    project: {
        title,
        subType,
        position,
        visible,
        type,
        youTubeVideo,
        vimeoVideo,
        year,
        awards,
    },
    onClick,
    onDelete,
    onView,
}: Props) => {
    const { i18n } = useTranslation();

    return (
        <Card
            onClick={onClick}
            actions={
                <>
                    {youTubeVideo && (
                        <IconBootstrap name="youtube" className="ms-2" />
                    )}
                    {vimeoVideo && (
                        <IconBootstrap name="vimeo" className="ms-2" />
                    )}
                    {year && year !== 0 && (
                        <Badge className="ms-2">{year}</Badge>
                    )}
                    <Badge color="secondary" className="ms-2">
                        {type}
                    </Badge>
                    <Badge color="secondary" className="ms-2">
                        {subType}
                    </Badge>
                    {awards && (
                        <Badge className="ms-2 d-flex justify-content-center align-items-center">
                            {awards.length}
                            <IconBootstrap
                                name="trophy"
                                className="ms-2"
                                color="white"
                                size="xs"
                            />
                        </Badge>
                    )}
                    {position && <Badge className="ms-2">{position}</Badge>}
                    {onView && <ViewButton onClick={onView} />}
                    {onDelete && <DeleteButton onClick={onDelete} />}
                </>
            }
            m={2}
            p={2}
        >
            <IconBootstrap
                name={visible ? 'eye' : 'eye-slash'}
                className="me-2"
            />
            <div className="d-flex flex-column">
                {i18n.languages.map((language) => (
                    <span key={language}>
                        <Badge className="mx-1">{language}</Badge>
                        {title?.[language as keyof TranslatedString]}
                    </span>
                ))}
            </div>
        </Card>
    );
};
